<template>
  <section class="single-cat">
    <article>
      <div class="row clearfix">
        <h1>
          Classical Music
          <!-- <a href="javascript:;" data-table="category-trends-table" class="infotoggle inline tooltipstered">Click for more info</a> -->
        </h1>
        <div class="sixcol">
          <p>In 2025, <strong>Classical Music</strong> generated $133.1m in revenue and attracted close to 1.5m attendances. These results represent the highest-ever recorded revenue and attendance for this category.</p>
          <p><strong>Classical Music</strong> recorded a y-o-y increase in revenue of 28.6% (from $103.5m in 2024 to $133.1m in 2025) and a y-o-y increase in attendance of 6.7% (from 1.4m in 2024 to 1.5m in 2025). An increase in the average ticket price of 19.2% y-o-y (from $89.03 in 2024 to $106.10 in 2025) also contributed to the growth in revenue.</p>
          <p>Revenue in this category was primarily driven by major events such as <em>Hans Zimmer Live</em>, <em>The Music of Joe Hisaishi</em>, <em>The Salvation Army’s Carols in the Domain</em> and performances by Andrea Bocelli.</p>
          <p>Similar to previous years, performances by NPAP companies contributed significantly to the revenue (49.8%) and attendance (58.1%) in this category in 2025. NPAP companies include Adelaide Symphony Orchestra, Australian Brandenburg Orchestra, Australian Chamber Orchestra, Melbourne Symphony Orchestra, Musica Viva Australia, Orchestra Victoria, Queensland Symphony Orchestra, Sydney Symphony Orchestra, Tasmanian Symphony Orchestra and West Australian Symphony Orchestra.</p>
        </div>
        <div class="sixcol last">
          <p>In 2025, NSW and VIC generated the most revenue and attendance in this category. These two states combined generated 73.3% of overall revenue and 70.2% of overall attendance in this category.</p>
          <p>Top events in NSW and VIC included performances by Andrea Bocelli and events such as <em>Hans Zimmer Live</em>, <em>Top Gun Maverick in Concert</em>, <em>How to Train Your Dragon in Concert</em>, <em>Beethoven's Ninth Symphony with Simone Young</em> and <em>Avatar: The Last Airbender in Concert</em>.</p>
          <p>In 2025, all states and territories except for WA, SA and TAS recorded y-o-y growth in both revenue and attendance.</p>
          <p>NT recorded the highest y-o-y growth in revenue (59.7%) and ACT recorded the highest y-o-y growth in attendance (20.2%) in 2025.</p>
          <p>NSW recorded the second-highest y-o-y growth in revenue (51.8%) and third-highest y-o-y growth in attendance (15.4%) in 2025. QLD recorded the third-highest y-o-y growth in revenue (48.3%) and second-highest y-o-y growth in attendance (16.1%) in 2025.</p>
        </div>
      </div>
    </article>

    <figure class="chart">
      <div class="row clearfix">
        <highcharts class="graphcontainer" :options="totalRevenueAttendance"></highcharts>
      </div>
    </figure>

    <figure id="classical-music-states" class="chart">
      <div class="row clearfix">
        <h1>State/Territory Breakdown</h1>

        <div class="chart-wrapper">
          <highcharts class="graphcontainer" :options="activeStateBreakdown"></highcharts>
          <div class="nb">NB: Numbers may not total 100.0% due to rounding.<br>Categories/States with zero or &lt;0.05% of revenue and/or attendance<br> may not be reflected in the pie chart.</div>
        </div>
      </div>
    </figure>

    <div class="row clearfix">
      <h2 id="download-btn">Download the Report</h2>
      <div class="execsumm" style="justify-content: center;">
        <a href="./pdf/2025/CLASSICAL MUSIC  Live Performance Industry in 2025.pdf" class="button fullreport pdf" target="_blank">
          Classical Music Infographic Report 2025 (PDF)
        </a>
      </div>
    </div>

    <div class="fullbg">
      <p class="caption">Photo: <em>Final Sunset</em>, Australian Festival of Chamber Music, Photo Credit: Peter Hislop</p>
    </div>
  </section>
</template>

<script>
/*eslint-disable */

export default {
  data () {
    return {
      totalRevenueAttendance: {
        chart: {
          backgroundColor: null,
        },
        title: {
          text: ''
        },
        xAxis: [{
          categories: ["2004", "2005", "2006", "2007", "2008", "2009", "2010", "2011", "2012", "2013", "2014", "2015", "2016", "2017", "2018", "2019", "2020", "2021", "2022", "2023", "2024", "2025"],
          labels: {
            style: {
              color: '#fff'
            }
          }
        }],
        yAxis: [{ // Primary yAxis
          min: 0,
          labels: {
            formatter: function() {
              if (this.value > 999) {
                return '$' + (this.value / 1000) + 'b'
              } else {
                return '$' + this.value + 'm'
              }
            },
            style: {
              color: '#fff'
            }
          },
          title: {
            text: 'Gross Revenue',
            style: {
              color: '#fff'
            }
          },
          opposite: true
        }, { // Secondary yAxis
          min: 0,
          labels: {
            formatter: function() {
              if (this.value < 1) {
                return (this.value * 1000) + 'k'
              } else {
                return this.value + 'm'
              }
            },
            style: {
              color: '#fff'
            }
          },
          title: {
            text: 'Total Attendance',
            style: {
              color: '#fff'
            }
          },
          opposite: false
        }],
        tooltip: {
          shared: true,
          formatter: function() {
            let revy, tooltipstring;
            let rev = this.points[0];
            let att = this.points[1];
            let atty = att.y + 'm';
            let chart = this.points[0].series.chart;
            let categories = chart.xAxis[0].categories;
            let index = 0;
            while (this.x !== categories[index]) {
              index++;
            }
            if (rev.y > 1000) {
              revy = '$' + (rev.y / 1000).toFixed(2) + 'b'
            } else {
              revy = '$' + rev.y.toFixed(3) + 'm'
            }
            if (att.y < 1) {
              atty = (att.y * 1000).toFixed(0) + 'k'
            } else {
              atty = att.y + 'm'
            }

            tooltipstring = this.x + '<br />';
            tooltipstring += '<span style="color:' + rev.series.color + '">•</span> Revenue: ' + revy + '<br />'
            tooltipstring += '<span style="color:' + att.series.color + '">•</span> Attendance: ' + atty + '<br />'
            return tooltipstring
          }
        },
        legend: {
          layout: 'vertical',
          align: 'center',
          verticalAlign: 'bottom',
          floating: false,
          backgroundColor: '#FFFFFF'
        },
        series: [{
          name: 'Revenue',
          type: 'column',
          data: [41.876, 54.396, 67.569, 54.615, 107.05, 71.273, 45.882, 60.096, 60.884, 70.482, 64.87, 56.396, 76.764, 77.883, 79.457, 87.333, 18.111, 37.973, 88.922, 90.366, 103.495, 133.08],
          color: '#3a89eb'
        }, {
          name: 'Attendance',
          type: 'column',
          yAxis: 1,
          data: [1.062, 1.154, 1.572, 1.104, 1.478, 1.12, 0.962, 1.048, 1.255, 1.17, 1.015, 0.994, 1.219, 1.318, 1.262, 1.316, 0.29, 0.595, 1.176, 1.293, 1.391, 1.484],
          color: '#d14967'
        }]
      },
      activeYear: 2025,
      stateBreakdowns: [
        {
          year: 2025,
          revenue: [
            ["NSW", 47.4],
            ["VIC", 25.9],
            ["QLD", 13.4],
            ["WA", 6.7],
            ["SA", 4.0],
            ["ACT", 1.2],
            ["TAS", 1.2],
            ["NT", 0.1],
          ],
          attendance: [
            ["NSW", 37.8],
            ["VIC", 32.4],
            ["QLD", 12.8],
            ["WA", 8.8],
            ["SA", 4.5],
            ["ACT", 1.3],
            ["TAS", 1.9],
            ["NT", 0.6],
          ]
        },
      ],
    }
  },
  mounted () {
    window.scrollTo(0, 0)
  },
  computed: {
    activeStateBreakdown () {
      const self = this

      for (let i = 0; i < self.stateBreakdowns.length; i++) {
        const stateBreakdown = self.stateBreakdowns[i]
        if (stateBreakdown.year === self.activeYear) {
          return {
            chart: {
              type: 'pie',
              backgroundColor: 'transparent'
            },
            title: {
              text: ''
            },
            subtitle: {
              text: ''
            },
            plotOptions: {
              series: {
                states: {
                  inactive: {
                    opacity: 1
                  }
                }
              },
              pie: {
                shadow: false,
                center: ['50%', '50%'],
                dataLabels: {
                  enabled: true,
                  style: {
                    fontWeight: 'bold',
                    color: 'white',
                    textShadow: '0px 1px 2px black'
                  }
                },
                point: {
                  events: {
                    legendItemClick: e => {
                      e.preventDefault();
                      return false;
                    }
                  }
                }
              }
            },
            legend: {
              align: 'right',
              layout: 'vertical',
              verticalAlign: 'middle',
              itemMarginBottom: 10,
              itemStyle: {
                color: '#fff'
              },
              itemHoverStyle: {
                color: '#fff'
              }
            },
            tooltip: {
              valueSuffix: '%',
              valueDecimals: 1
            },
            series: [
              {
                name: 'Attendance Share',
                data: stateBreakdown.attendance,
                size: '68%',
                innerSize: '40%',
                borderColor: 'none',
                borderWidth: 1,
                slicedOffset: 30,
                showInLegend: true,
                dataLabels: {
                  color: '#000',
                  style: {
                    textShadow: 'none',
                  },
                  formatter: function() {
                    if (this.y > 3) {
                      return this.y.toFixed(1) + '% '
                    }
                  },
                  distance: -28
                }
              }, 
              {
                name: 'Revenue Share',
                data: stateBreakdown.revenue,
                size: '100%',
                innerSize: '70%',
                borderColor: 'transparent',
                borderWidth: 1,
                dataLabels: {
                  color: '#000',
                  style: {
                    textShadow: 'none',
                  },
                  formatter: function() {
                    if (this.y > 3) {
                      return this.y.toFixed(1) + '% '
                    }
                  },
                  distance: -32
                }
              }
            ],
            colors: [
              '#f66262',
              '#f2914a',
              '#5fa62b',
              '#6598d3',
              '#594ebb',
              '#bc56c3',
              '#c3567f',
              '#edc055'
            ]
          }
        }
      }

      return false
    }
  }
}
</script>

<style lang="scss" scoped="scoped">
.single-cat {
  background-image: url("~@/assets/img/2025/21 Classical Music AFCM 2025_20250801b 057 Final Sunset_photo credit Peter Hislop.jpg");
  background-position: center top;
}
.chart-wrapper {
  position: relative;
  .nb {
    position: absolute;
    bottom: 0;
    right: 0;
    color: #fff;
    font-style: italic;
    font-size: 12px;
  }
}
</style>
